var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-left.svg",
    clipPath: "url(#clip0_8_9802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.37609 8.14137C9.84339 8.61558 9.84339 9.38442 9.37609 9.85863L2.19654 17.1443C1.72925 17.6186 0.97161 17.6186 0.50431 17.1443C0.0370092 16.6701 0.0370092 15.9013 0.50431 15.4271L6.83774 9L0.50431 2.5729C0.0370092 2.0987 0.0370092 1.3299 0.50431 0.8557C0.97161 0.381399 1.72925 0.381399 2.19654 0.8557L9.37609 8.14137Z",
    fill: "#0C4ACF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_9802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 17,
    fill: "white",
    transform: "matrix(-1 0 0 -1 10 17.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/arrowright.3eec05e63125b7cc5d054c771a581fb4.svg";
export { ForwardRef as ReactComponent };